// extracted by mini-css-extract-plugin
module.exports = {"table-data-label":"table-data-label-34e2fc4bad159c112f8166d6e50eef2c","meal-list-radio":"meal-list-radio-91eb88bc6fcb0a0190662ec46a9e5cb2"};